import React, { useId } from 'react'
import { useI18n } from '../../i18n/I18nContext'
import type { DensityPreference } from '../../hooks/useInterfaceDensity'
import { INTERFACE_DENSITIES, type InterfaceDensity } from '../../services/interfacePreferences'

const labels: Record<InterfaceDensity, string> = {
  compact: 'Compact', comfortable: 'Comfortable', spacious: 'Spacious',
}

/** Controlled display setting: persistence belongs entirely to the shared hook. */
export const DensitySelector: React.FC<{ preference: DensityPreference }> = ({ preference }) => {
  const { t } = useI18n()
  const id = useId()
  return <div className="interface-density-control">
    <label htmlFor={id}>{t('Table density')}</label>
    <select
      id={id}
      className="input"
      value={preference.density}
      disabled={!preference.enabled}
      aria-describedby={preference.enabled && !preference.persisted ? `${id}-status` : undefined}
      onChange={event => preference.setDensity(event.target.value as InterfaceDensity)}
    >
      {INTERFACE_DENSITIES.map(density => <option key={density} value={density}>{t(labels[density])}</option>)}
    </select>
    {preference.enabled && !preference.persisted ? <p id={`${id}-status`} className="helper" role="status">
      {t('Density changed, but could not be saved in this browser.')}
    </p> : null}
  </div>
}
